import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const VISITOR_KEY = 'jbss-visitor-id';
const LAST_KEY = 'jbss-visit-last';

const todayIST = () => new Date(Date.now() + 5.5 * 3600 * 1000).toISOString().slice(0, 10);

const getVisitorId = () => {
  let id = localStorage.getItem(VISITOR_KEY);
  if (!id) {
    id = (window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`);
    localStorage.setItem(VISITOR_KEY, id);
  }
  return id;
};

export const useVisitTracker = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (pathname.startsWith('/admin')) return;
    const day = todayIST();
    if (localStorage.getItem(LAST_KEY) === day) return;
    axios.post(`${API}/visits`, { visitor_id: getVisitorId() })
      .then(() => localStorage.setItem(LAST_KEY, day))
      .catch(() => {});
  }, [pathname]);
};
